import React, { FC } from "react";
import cn from "classnames";
import { RenderFormFields } from "src/components/RenderFormFields";
import { StepWrapper } from "../StepWrapper";
import { ICalculatorStepProps } from "../types";

interface Props extends ICalculatorStepProps {}

export const DefaultStep: FC<Props> = ({
  title,
  titleClassName,
  className,
  fields,
  withAnimation,
}) => (
  <StepWrapper className={className} withAnimation={withAnimation}>
    {title ? (
      <h3
        className={cn("text-green-base font-black leading-none", titleClassName)}
      >
        {title}
      </h3>
    ) : null}

    <div>
      <RenderFormFields fields={fields} />
    </div>
  </StepWrapper>
);
